import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { FileImage } from '@/common/constants';
import { API_URL } from '@/dtos';
import { extractFilenameFromS3Url } from '@/utils/handlers';
import { getFileType } from '@/utils/modifiers/getFileType';

export const QUERY_KEY = 'getFilesByDocumentId';

const getFilesByDocumentId = (documentId?: string) =>
  api.get(API_URL.DOCUMENTS_FILES_BY_DOCUMENT_ID(documentId || ''));

interface FileUrls {
  id: number;
  s3_url: string;
}

const useFilesByDocumentIdQuery = (documentId?: string) => {
  const { isLoading, error, data, isSuccess, refetch } = useQuery(
    [QUERY_KEY, documentId],
    () => getFilesByDocumentId(documentId),
    { enabled: Boolean(documentId), cacheTime: 0 }
  );

  const formattedData = useMemo(
    () =>
      data?.data?.files?.map(
        (file: FileUrls): FileImage => ({
          id: toString(file.id),
          path: file.s3_url,
          url: file.s3_url,
          type: getFileType(file.s3_url) as string,
          preview: '',
          name: extractFilenameFromS3Url(file.s3_url),
          temporalId: toString(file.id),
        })
      ),
    [data]
  );

  return {
    files: formattedData,
    error,
    isLoading,
    isSuccess,
    refetch,
  };
};

export default useFilesByDocumentIdQuery;
